import { ACADEMIC_STATUS_MAP } from 'constants/academic-status-map';

const ACADEMIC_RECORD_EVENTS_TRANSLATIONS = new Map<string, string>([
  ['create', 'Criado'],
  ['update', 'Atualizado'],
  ['delete', 'Deletado']
]);

export const translateAcademicRecordStatus = (status: string) => {
  return ACADEMIC_STATUS_MAP[status as keyof typeof ACADEMIC_STATUS_MAP]?.label;
};

export const translateAcademicRecordEventStatus = (status: string): string =>
  ACADEMIC_RECORD_EVENTS_TRANSLATIONS.get(status) || status;
